import {DossierDate, DossierOGRNType, DossierT11, DossierT250} from "./base.model";

export class RegInfoType {
  ogrn?: DossierOGRNType = '';
  dateReg?: DossierDate = '';
  dateRegIn?: DossierDate = '';
  regNum?: DossierT11 = '';
  nameRegOrg?: DossierT250 = '';
}
